module.exports = __webpack_public_path__ + "static/media/InfoIcon.5130bd28.svg";